"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3053,624],{

/***/ 73238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ BreadcrumbLink; },
/* harmony export */   "aG": function() { return /* binding */ Breadcrumb; },
/* harmony export */   "gN": function() { return /* binding */ BreadcrumbItem; }
/* harmony export */ });
/* unused harmony exports BreadcrumbSeparator, useBreadcrumbStyles */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34031);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54520);
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28387);
// ../../../react-shim.js


// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");

// src/breadcrumb.tsx




// src/breadcrumb-context.ts

var [BreadcrumbStylesProvider, useBreadcrumbStyles] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .k)({
  name: `BreadcrumbStylesContext`,
  errorMessage: `useBreadcrumbStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Breadcrumb />" `
});

// src/breadcrumb.tsx
var Breadcrumb = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function Breadcrumb2(props, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .useMultiStyleConfig */ .jC)("Breadcrumb", props);
  const ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .Lr)(props);
  const {
    children,
    spacing = "0.5rem",
    separator = "/",
    className,
    listProps,
    ...rest
  } = ownProps;
  const validChildren = (0,_chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_4__/* .getValidChildren */ .W)(children);
  const count = validChildren.length;
  const clones = validChildren.map((child, index) => (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
    separator,
    spacing,
    isLastChild: count === index + 1
  }));
  const _className = cx("chakra-breadcrumb", className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.nav */ .m$.nav, {
    ref,
    "aria-label": "breadcrumb",
    className: _className,
    __css: styles.container,
    ...rest
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BreadcrumbStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.ol */ .m$.ol, {
    className: "chakra-breadcrumb__list",
    ...listProps,
    __css: {
      display: "flex",
      alignItems: "center",
      ...styles.list
    }
  }, clones)));
});
Breadcrumb.displayName = "Breadcrumb";

// src/breadcrumb-item.tsx



// src/breadcrumb-separator.tsx

var BreadcrumbSeparator = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbSeparator2(props, ref) {
  const { spacing, ...rest } = props;
  const styles = useBreadcrumbStyles();
  const separatorStyles = {
    mx: spacing,
    ...styles.separator
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
    ref,
    role: "presentation",
    ...rest,
    __css: separatorStyles
  });
});
BreadcrumbSeparator.displayName = "BreadcrumbSeparator";

// src/breadcrumb-link.tsx

var BreadcrumbLink = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbLink2(props, ref) {
  const { isCurrentPage, as, className, href, ...rest } = props;
  const styles = useBreadcrumbStyles();
  const sharedProps = {
    ref,
    as,
    className: cx("chakra-breadcrumb__link", className),
    ...rest
  };
  if (isCurrentPage) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
      "aria-current": "page",
      __css: styles.link,
      ...sharedProps
    });
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.a */ .m$.a, {
    __css: styles.link,
    href,
    ...sharedProps
  });
});
BreadcrumbLink.displayName = "BreadcrumbLink";

// src/breadcrumb-item.tsx

var BreadcrumbItem = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbItem2(props, ref) {
  const {
    isCurrentPage,
    separator,
    isLastChild,
    spacing,
    children,
    className,
    ...rest
  } = props;
  const validChildren = (0,_chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_4__/* .getValidChildren */ .W)(children);
  const clones = validChildren.map((child) => {
    if (child.type === BreadcrumbLink) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        isCurrentPage
      });
    }
    if (child.type === BreadcrumbSeparator) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        spacing,
        children: child.props.children || separator
      });
    }
    return child;
  });
  const styles = useBreadcrumbStyles();
  const itemStyles = {
    display: "inline-flex",
    alignItems: "center",
    ...styles.item
  };
  const _className = cx("chakra-breadcrumb__list-item", className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.li */ .m$.li, {
    ref,
    className: _className,
    ...rest,
    __css: itemStyles
  }, clones, !isLastChild && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BreadcrumbSeparator, {
    spacing
  }, separator));
});
BreadcrumbItem.displayName = "BreadcrumbItem";



/***/ }),

/***/ 33053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73238);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3382);
/* harmony import */ var src_components_common_StructuredData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7259);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);








const Breadcrumbs = _ref => {
  let {
    items
  } = _ref;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_StructuredData__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      breadcrumbData: items
    }), items && items.length ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
      as: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Stack */ .Kq,
      p: "l",
      alignContent: "left",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Breadcrumb */ .aG, {
        fontFamily: "Montserrat-Medium",
        fontSize: ".875rem",
        color: "baseDark",
        letterSpacing: ".2px",
        lineHeight: "18px",
        textAlign: "left",
        separator: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_5__/* .ChevronRightIcon */ .XC, {
          color: "baseDark"
        }),
        children: items.map((item, index) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .BreadcrumbItem */ .gN, {
          children: item.href ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .BreadcrumbLink */ .At, {
            isCurrentPage: index === items.length - 1,
            href: item.href,
            title: item.title,
            color: index !== items.length - 1 ? 'baseDark' : 'baseNeutral.700',
            _hover: {
              textDecoration: 'none',
              color: 'baseNeutral.700'
            },
            children: item.page
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
            children: item.title
          })
        }, item.page))
      })
    }) : null]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Breadcrumbs);

/***/ }),

/***/ 7259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const Breadcrumb = _ref => {
  let {
    breadcrumbData
  } = _ref;
  const data = {
    "@context": "https://schema.org/",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbData.map((crumbItem, idx) => ({
      "@type": "ListItem",
      "position": idx + 1,
      "name": crumbItem.title,
      "item": `https://carplanner.com${crumbItem.href}`
    }))
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("script", {
      type: "application/ld+json",
      id: "structuredDataBreadcrumb",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(data)
      }
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumb);

/***/ })

}]);